import React, { useState } from 'react';
import moment from 'moment';

import TextArea from '../../../../../../../../common/data-entry/TextArea';
import ModalBoxes from '../../../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../../../../common/general/Button';
import Icon from '../../../../../../../../common/general/Icon';
import { dateFormat, TRAVEL_TOPIC } from '../../taskConstants';

import TaskCommentsModal from './TaskCommentsModal/TaskCommentsModal';

export default function TaskDetailsComments({ taskForm, setTaskCommentField, taskId, ssuId, onTravelCommentsUpdated }) {
  const { taskComments, taskCommentField } = taskForm;
  const [editMode, setEditMode] = useState(false);
  const isTravelTask = taskForm?.topicType === TRAVEL_TOPIC;
  const hasComments = (taskComments?.length || 0) > 0;
  const canOpenTravelComments = Boolean(taskId && ssuId);

  return (
    <div className="etc-body-details">
      <div className="etc-body-details-block">
        <div className="etc-body-details-block-label etc-body-details-comments-label">
          Comments
          {isTravelTask ? (
            <Button onClick={openTaskCommentsModal} priority="medium" size="h28" disabled={!canOpenTravelComments}>
              {hasComments ? (
                <>
                  <Icon>visibility</Icon> View
                </>
              ) : (
                <>
                  <Icon>add</Icon> Add
                </>
              )}
            </Button>
          ) : (
            <Button onClick={() => setEditMode(!editMode)} priority="medium" size="h28">
              <Icon>add</Icon> Add
            </Button>
          )}
        </div>
        <div className="etc-body-details-block-value">
          {!isTravelTask && editMode && (
            <TextArea
              id="add-comment-input"
              name="description"
              value={taskCommentField}
              onChange={({ target }) => {
                setTaskCommentField(target.value);
              }}
              maxLength="300"
              showCount
            />
          )}
          {!isTravelTask &&
            taskComments?.map(comment => (
              <div className="etc-body-details-comment" key={comment.creationDate}>
                <Icon suit={'material-outline'}>forum</Icon>
                <p>
                  {`${formatDate(comment.creationDate)} by ${comment?.createdByFirstName} ${
                    comment?.createdByLastName
                  }`}
                  :<span>{`${comment?.commentText}`}</span>
                </p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );

  function openTaskCommentsModal() {
    if (!taskId || !ssuId) return;
    ModalBoxes.open({
      component: (
        <TaskCommentsModal
          taskId={taskId}
          ssuId={ssuId}
          taskComments={taskComments}
          onCommentsChanged={onTravelCommentsUpdated}
          initWithDraftComment={!hasComments}
        />
      )
    });
  }
}

function formatDate(str) {
  return moment(str).format(dateFormat);
}
